import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters } from "./config";

const ServiceList = () => {

  return (
    <Table tableId="services" title="Service" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="name" idKey="service_id" fieldsToSearch={["Name", "Category"]} view={false} />
  );
};

export default ServiceList;